import { Component } from '@angular/core';

@Component({
  selector: 'app-bell-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './bell-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class BellIconComponent {}
